import { ApplicationConfig, provideZoneChangeDetection, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServerRendering } from '@angular/platform-server';

import { provideLottieOptions } from 'ngx-lottie';
import { FOOTER_BASE_HREF } from '@flitpay-internal/web-footer';
import { HEADER_BASE_HREF } from '@flitpay-internal/web-header';
import { provideGraphQLClient } from '@flitpay-internal/resources';
import { environment } from '../environments/environment';

const getApiUrl = (platformId: Object): string => {
	if (isPlatformServer(platformId)) {
		return environment.apiUrlOnServer ?? '';
	}
	return environment.apiUrl ?? '';
};

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideServerRendering(),
		provideRouter(routes,
			withEnabledBlockingInitialNavigation(),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
		),
		// {
		// 	provide: 'GRAPHQL_CLIENT',
		// 	useFactory: (platformId: Object) => provideGraphQLClient({
		// 		uri: `${getApiUrl(platformId)}graphql`,
		// 		tokenType: 'JWT'
		// 	}),
		// 	deps: [PLATFORM_ID]
		// },
		provideGraphQLClient({
			uri: getApiUrl(PLATFORM_ID) + 'graphql',
			tokenType: 'JWT' // or 'Bearer'
		}),
		provideClientHydration(),
		provideHttpClient(
			withFetch(),
			// withInterceptors([authInterceptor])>
		),
		provideAnimations(),
		provideLottieOptions({
			player: () => import('lottie-web'),
		}),
		{ provide: FOOTER_BASE_HREF, useValue: '/blog/' },
		{ provide: HEADER_BASE_HREF, useValue: '/blog/' }
	]
};
